import React, { useState } from "react";
import Styles from "./Styles.module.css";
import { CiSearch } from "react-icons/ci";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import INF1 from "../../../../Assets/images/image-not-available.jpg";



function RightCard({ data, rightModalClick, sx }) {
  const [imageError, setImageError] = useState({});
   const [searchTerm, setSearchTerm] = useState("");

  // console.log("my_data:", data);

  // Handle image error (fallback to pizza image)
  const handleImageError = (index) => {
    setImageError((prev) => ({ ...prev, [index]: true }));
  };

  // Filter deliveries based on search term
  // const filteredData = data?.filter(
  //   (item) =>
  //     item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     item.description.toLowerCase().includes(searchTerm.toLowerCase())
  // );
  const filteredData = data?.filter((item) =>
    item?.name?.toLowerCase().includes(searchTerm?.toLowerCase())
  );

  return (
    <div style={sx || {}} className={`${Styles.navContainer} w-[500px]`}>
      <div className={Styles.nav}>
        <div className={Styles.border_search}>
          <input
            type="text"
            style={{
              border: "none",
              outline: "none",
              backgroundColor: "transparent",
            }}
            placeholder="Search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <CiSearch size={"1.1rem"} />
        </div>

        {/* Map over the data prop to display each delivery item */}
        {filteredData?.map((item, index) => (
          <div
            key={index}
            onClick={() => rightModalClick(item)} // Pass the clicked item to the parent
            className="flex rounded shadow-lg h-1/5 justify-start gap-x-5  items-center p-4 cursor-pointer"
          >
            {/* Image handling with LazyLoadImage */}
            <div >
              <LazyLoadImage
                src={imageError[index] ? INF1 : item.default_image}
                alt={item.name}
                effect="blur"
                className=" w-25 h-20 self-start object-cover rounded"
                onError={() => handleImageError(index)}
              />
            </div>

            {/* Display delivery name and description */}
            <div className="flex flex-col  ">
              <p className="font-bold text-black text-lg">{item.name}</p>
              <p className="text-gray-600 text-base">{item.description}</p>
            </div>
          </div>
        ))}

        {/* Display a message if no deliveries match the search term */}
        {filteredData?.length === 0 && (
          <p className="text-center text-gray-500 mt-4">No deliveries found</p>
        )}
      </div>
    </div>
  );
}

export default RightCard;
